import { render, staticRenderFns } from "./RepairRequest2.vue?vue&type=template&id=58213bdc&"
import script from "./RepairRequest2.vue?vue&type=script&lang=js&"
export * from "./RepairRequest2.vue?vue&type=script&lang=js&"
import style0 from "./RepairRequest2.vue?vue&type=style&index=0&id=58213bdc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports